import { render, staticRenderFns } from "./BaseEtymVarNewEdit.vue?vue&type=template&id=3c83b51b&scoped=true&"
import script from "./BaseEtymVarNewEdit.vue?vue&type=script&lang=js&"
export * from "./BaseEtymVarNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c83b51b",
  null
  
)

export default component.exports